import * as Types from "@/lib/types";

export const defaultError: Types.ErrorUI = {
  isVisible: false,
  type: "",
  title: "",
  message: "",
  details: {
    message: "",
    code: "",
    stack: "",
    context: {},
  },
};

export const defaultChatMessage: Types.ChatMessage[] = [
  {
    id: "welcome",
    content:
      "Hello👋, I'm Jenly.AI, your Regulatory Affairs AI assistant. I can answer questions about your documents. How can I help you today?",
    role: "assistant",
    timestamp: new Date(),
  },
];

export const defaultFeedbackContent: Types.FeedbackContent = {
  chat_id: "",
  section: {},
  feedback: "",
};

export const defaultRegenerateContent: Types.RegenerateContent = {
  chat_id: "",
  section: {},
  freeform: "",
  options: [],
};

export const defaultQualityCheckContent: Types.QualityCheckContent = {
  name: "",
  value: 0.5,
  description: "",
};
